import _ from "lodash";
import { Languages } from "src/resources/enum";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "src/resources/constant";
import { MAX_FILE_SIZE } from "src/resources/constant";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import cookies from "js-cookie";
import { LANGuAGE_COOKIE, IS_CIVIL_DEFENSE } from "../resources/constant";
import moment from "moment";
import { parse } from "date-fns";

export const isNullOrWhiteSpace = (str: any): boolean => {
  if (!_.isString(str)) {
    str = _.toString(str);
  }
  return _.isEmpty(_.trim(str));
};

export const convertDateIFNotMin = (date: any): string => {
  let formattedDate =
    date && date !== "0001-01-01T00:00:00"
      ? moment(date).format("DD/MM/YYYY")
      : "";
  return formattedDate;
};

export const getPathNames = (location: any) => {
  return location.pathname
    .split("/")
    .filter((pathname: any) => pathname !== "");
};

export function kebabToCamelCase(str: string): string {
  return str
    .split("-")
    .map((word, index) => {
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join("");
}
export function camelCaseToTitle(camelCase: string): string {
  const titleCase = camelCase
    // .replace("BMC", "BMC")
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .replace("Bmc", "BMC")
    .trim();
  const abbreviations = [
    { value: /\bbmc\b/gi, replacement: "BMC" },
    { value: /\bate\b/gi, replacement: "ATE" },
    { value: /\bFaqs\b/gi, replacement: "FAQs" },
  ];

  return abbreviations.reduce((result, { value, replacement }) => {
    return result.replace(value, replacement);
  }, titleCase);
}
export const getCurrentDateTimeString = (): string => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${day}-${month}-${year}_${hours}-${minutes}-${seconds}`;
};

export const getCurrentDateTimeFormatted = (format = ""): string => {
  if (format) return moment().format(format);
  else return moment().format("DD/MM/YYYY - HH:mm:ss");
};

moment.defaultFormat = "DD/MM/YYYY";

export const convertIsoStringToDate = (isoString: string): Date => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  //return new Date(isoString);
  if (isoString) {
    const format = "dd-MM-yyyy";
    var test = parse(`${day}-${month}-${year}`, format, new Date());
    return test;
  } else return new Date(isoString);
  //return `${day}/${month}/${year}`;
  //return moment(date).format(moment.defaultFormat);
};

export const isCivilDefenseUser = () => {
  var pathName = window.location.pathname;
  var isCivilDefense =
    cookies.get(IS_CIVIL_DEFENSE) === "true" || pathName.includes("breached")
      ? true
      : false;
  return isCivilDefense;
};

export const formatDateV2 = (isoString: string): string => {
  if (!isoString) return "";
  let newDate;
  if (isoString.includes("00Z")) {
    newDate = moment(isoString).utcOffset(0);
  } else if (isoString.includes("T")) {
    const isoDate = convertToISO(isoString);
    newDate = moment(isoDate);
  }

  newDate = newDate?.format("DD/MMM/YYYY") ?? "";
  return newDate;
};

export const convertToISO = (dateString: string | null): string => {
  if (dateString === null) return "";
  const date = new Date(dateString);
  const timezoneOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
  const localISOTime = new Date(date.getTime() - timezoneOffset).toISOString();
  return localISOTime.split(".")[0] + "Z"; // Remove milliseconds and add 'Z' to indicate UTC
};
export function isRtl(lang: any): boolean {
  return lang === Languages.Arabic;
}

export function isArabic(): boolean {
  const siteLanguage = getSiteLanguage();
  return siteLanguage === Languages.Arabic;
}

export function downloadFile(file: any, maxFileErrorMessage: string) {
  if (!file) return;
  const fileBase64 = file.fileBase64;
  const fileSize = calculateFileSizeFromBase64(fileBase64);
  if (fileSize > MAX_FILE_SIZE) {
    toast.error(maxFileErrorMessage);
    return;
  }
  const downloadLink = document.createElement("a");
  downloadLink.href = fileBase64;
  downloadLink.download = file.fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export function encryptPassword(plainText: string, key = SECRET_KEY) {
  const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

export const calculateFileSizeFromBase64 = (base64String: string): number => {
  const base64WithoutPrefix = base64String.split(",")[1] || base64String;
  const base64Length = base64WithoutPrefix.length;
  const fileSizeInBytes =
    (base64Length * 3) / 4 -
    (base64WithoutPrefix.endsWith("==")
      ? 2
      : base64WithoutPrefix.endsWith("=")
      ? 1
      : 0);
  return fileSizeInBytes;
};

export function replaceDefaultArrow(portalElement: HTMLDivElement) {
  const defaultArrow = document.querySelector(".p-icon.p-button-icon.p-c");
  if (defaultArrow) {
    defaultArrow.remove();
  }

  const svgElement = getSVGArrow();
  portalElement.appendChild(svgElement);
}

export function getSVGArrow() {
  const svgElement = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "svg"
  );
  svgElement.setAttribute("class", "custom-arrow-down");
  svgElement.setAttribute("width", "10");
  svgElement.setAttribute("height", "5");
  svgElement.setAttribute("viewBox", "0 0 10 5");
  svgElement.setAttribute("fill", "none");

  const pathElement = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );
  pathElement.setAttribute(
    "d",
    "M4.4752 4.475L0.850195 0.85C0.800195 0.8 0.762695 0.745833 0.737695 0.6875C0.712695 0.629167 0.700195 0.566667 0.700195 0.5C0.700195 0.366667 0.746029 0.25 0.837695 0.15C0.929362 0.05 1.0502 0 1.2002 0H8.8002C8.9502 0 9.07103 0.05 9.1627 0.15C9.25436 0.25 9.3002 0.366667 9.3002 0.5C9.3002 0.533333 9.2502 0.65 9.1502 0.85L5.5252 4.475C5.44186 4.55833 5.35853 4.61667 5.2752 4.65C5.19186 4.68333 5.1002 4.7 5.0002 4.7C4.9002 4.7 4.80853 4.68333 4.7252 4.65C4.64186 4.61667 4.55853 4.55833 4.4752 4.475Z"
  );
  pathElement.setAttribute("fill", "white");

  svgElement.appendChild(pathElement);
  return svgElement;
}
export function scrollToTopWithClass(
  elementClass: string,
  parentClass: string | null
) {
  if (parentClass) {
    // for modal and popups
    const parentElement = document.querySelector(`.${parentClass}`);
    if (parentElement) {
      const element = parentElement.querySelector(`.${elementClass}`);
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + parentElement.scrollTop - 140;
        parentElement.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    }
  } else {
    const element = document.querySelector(`.${elementClass}`);
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - 40;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }
}

export function toCamel(o: any): any {
  if (!o) return o;
  let newO: any, origKey: string, newKey: string, value: any;
  if (o instanceof Array) {
    return o.map((value) => {
      if (typeof value === "object" && value !== null) {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        //.replace("ATE", "ate")
        newKey = origKey.replace("BMC", "bmc").replace("AMC", "amc");
        if (origKey === "ID") newKey = origKey.replace("ID", "id");
        newKey = (
          newKey.charAt(0).toLowerCase() + newKey.slice(1) || newKey
        ).toString();
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value?.constructor === Object)
        ) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
}

export function toPascal(o: any): any {
  let newO: any, origKey: string, newKey: string, value: any;
  if (o instanceof Array) {
    return o.map((value) => {
      if (typeof value === "object" && value !== null) {
        value = toPascal(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        //.replace("ate", "ATE")
        newKey = origKey.replace("bmc", "BMC").replace("amc", "AMC");
        newKey = (
          newKey.charAt(0).toUpperCase() + newKey.slice(1) || newKey
        ).toString();
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value?.constructor === Object)
        ) {
          value = toPascal(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
}
export function getStatusByStatusId(statuses: any, id: any) {
  const status = statuses.find((status: any) => status.id === id?.toString());
  return status;
}
export function getClassesBasedOnStatus(status: any): string | undefined {
  if (!status) return;
  return `${status.englishName
    .replace(/\s+/g, "-")
    .replace(/'/g, "-")
    .toLowerCase()}`;
}

export function getTextValueById(
  id: any,
  options: [],
  fieldName: string = "id"
) {
  if (!options || options.length === 0) return;
  const emirate = options?.find(
    (x: { [x: string]: any }) => x[fieldName] == id
  ) as { id: string; arabicName: string; englishName: string } | undefined;
  if (emirate) {
    return getFieldFieldValue(emirate);
  }
}
function getSiteLanguage() {
  const language = cookies.get(LANGuAGE_COOKIE)
    ? cookies.get(LANGuAGE_COOKIE)
    : Languages.English;
  return language;
}
export function getFieldFieldValue(field: { [x: string]: any }) {
  const language = cookies.get(LANGuAGE_COOKIE)
    ? cookies.get(LANGuAGE_COOKIE)
    : Languages.English;
  if (!field) return "";
  return isRtl(language) && field["arabicName"]
    ? field["arabicName"]
    : field["englishName"];
}
export const getFieldName = (language: string) => {
  return isRtl(language) ? "arabicName" : "englishName";
};

export const exportExcel = (data: [], fileName: string) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;",
  });
  saveAs(blob, fileName);
};
export const getFileName = (view: string) => {
  const formattedToday = getCurrentDateTimeString();
  return `${view} (${formattedToday}).xlsx`;
};

export const reorderObjectAttributes = (
  obj: object,
  orderedColumns: string[]
): object => {
  const firstPart = _.pick(obj, orderedColumns);
  return { ...firstPart };
};
export const reorderArrayOfObjects = (
  arr: object[],
  firstAttributes: string[]
): object[] => {
  return arr.map((obj) => reorderObjectAttributes(obj, firstAttributes));
};
export const isAllowedFileExtension = (fileExtension: string): boolean => {
  return ["pdf", "jpg", "jpeg"].includes(fileExtension);
};

export function convertDateToFullDateString(dateString: string): {
  day: string;
  month: string;
  year: string;
} {
  const [day, month, year] = dateString.split("/");
  const date = new Date(`${month} ${day}, ${year}`);
  const formattedDate = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
  const [_, newMonth, __] = formattedDate.split(" ");
  return { day, month: newMonth, year };
}

export const formatNumber = (number: number): string => {
  if(number == 0) return "0";
  if (!number) return "";
  if (number < 1000) return number.toString();
  if (number < 1000000) return (Math.floor(number / 100) / 10).toFixed(1) + "K";
  if (number < 1000000000)
    return (Math.floor(number / 100000) / 10).toFixed(1) + "M";
  return (Math.floor(number / 100000000) / 10).toFixed(1) + "B";
};
